module.exports = __webpack_public_path__ + "static/media/video-crisis-situation-es.95b010e4.vtt";